export const extractPaymentRegexMap = (mobileMoney: any) => {
  if (!mobileMoney || !mobileMoney.paymentOptions) return {};

  const regexMap: Record<string, string> = {};

  mobileMoney.paymentOptions.forEach((option: any) => {
    option?.paymentProviders?.forEach((provider: any) => {
      const uuid = provider?.paymentProviderInfo?.id?.uuid;
      const regex = provider?.paymentProviderInfo?.phoneNumberRegex;

      if (uuid && regex) {
        regexMap[uuid] = regex;
      }
    });
  });

  return regexMap;
};
